/**************************************************
 * toB
 **************************************************/
  const tob = {
  common: {},
  top: {},
  itemList: {},
  itemDetail: {},
  cart: {},
};

/**
* ヘッダーのおすすめアイテム
*/
tob.common.recommendSlider = function() {
  const mySwiper = new Swiper('.js-header-recommend', {
    slidesPerView: 2.6,
    freeMode: {
      enabled: true,// 自由にドラッグ（スワイプ）できるようにする
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
};

/**
* 一括カート追加の際に、カート更新のダイアログを表示
*/
tob.common.cartUpdatePopup = function() {
  const itemCount = document.querySelector('.header__icon--cart');// カート内数量
  const updatedPopup = document.getElementById('cart-updated-popup');// 「カート更新しました」のダイアログ
  
  if (!updatedPopup){
    return;
  }

  // 監視の設定
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      console.log(itemCount);
      // 数量が書き換わったら実行
      showCartPopup();
    });
  });

  // 監視開始（子要素とデータ両方をチェック）
  observer.observe(
    itemCount, { 
      childList: true, 
      characterData: true, 
      subtree: true 
    }
  );

  function showCartPopup() {
    updatedPopup.classList.add('cart-popup-visible');
    updatedPopup.classList.remove('cart-popup-hidden');

    // 3秒後に自動で消す
    setTimeout(() => {
      updatedPopup.classList.remove('cart-popup-visible');
      updatedPopup.classList.add('cart-popup-hidden');
    }, 3000);
  }
}

/**
 * ロゴ縮小の制御
 */
tob.common.headerLogoShrink = function() {
  // 設定値の変数化
  const config = {
    shrinkRatio: 0.7,   // スクロール時のロゴ画像の縮小率
    threshold: 50,      // スクロール量のしきい値（px）
  };

  // ヘッダーロゴ画像
  const logo = document.querySelector('.header__heading-logo');
  if (!logo) {
    return;
  }

  // 1. ページ読み込み時点のロゴの物理的な高さを取得（絶対値を排除）
  const originalHeight = logo.offsetHeight;

  window.addEventListener('scroll', () => {
    // 2. 50px以上スクロールしたら縮小、戻ったら元の高さへ
    if (window.scrollY > config.threshold) {
      logo.style.height = `${originalHeight * config.shrinkRatio}px`;
    } else {
      logo.style.height = `${originalHeight}px`;
    }
  });
}

/**
 * 商品リストで、スウォッチ画像をスライド
 */
tob.common.cardProductSlider = function() {
  if (typeof Swiper !== 'undefined') {
    const swiperElements = document.querySelectorAll('.js-card-variant-swiper');
    
    swiperElements.forEach(function(el) {
      // data属性から画像の枚数を数値として取得
      const totalItems = parseInt(el.dataset.totalImages || '0', 10);

      new Swiper(el, {
        slidesPerView: totalItems > 2 ? 2.6 : 2,
        spaceBetween: 5,
        freeMode: {
          enabled: totalItems > 2
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          // PCで5カラー以上のときスライダー化
          [illm.common.breakpoint.pc]: {
            slidesPerView: 4,
            freeMode: { enabled: totalItems > 4 }
          }
        }
      });
    });
  }
}

/**
 * メインビジュアルのスライダー
 */
tob.top.mainvisual = function() {
  const slideAutoplay = Boolean($('#illm-slide_autoplay').attr('date-info'));//自動再生: true
  const slideAutoplaySpeed = parseInt($('#illm-slide_autoplay_speed').attr('date-info'));//自動再生時の静止時間: 4000ms
  const slideSpeed = parseInt($('#illm-slide_speed').attr('date-info'));//スライドアニメーションの速度: 600ms
  const slideArrow = Boolean($('#illm-slide_arrow').attr('date-info'));//左右矢印の表示: true
  const slideDot = Boolean($('#illm-slide_dot').attr('date-info'));//ドットの表示: true
  const slideTarget = document.querySelector('.js-home-visual-swiper');//対象のスライド

  // スライドが1枚なら Swiper 自体不要
  const slideCount = slideTarget.querySelectorAll('.swiper-slide').length;
  if (slideCount <= 1) {
    return;
  }

  // Swiper初期化
  const homeVisualSwiper = new Swiper(slideTarget, {
    slidesPerView: 1,
    speed: slideSpeed,
    // 自動再生
    autoplay: slideAutoplay ? {
      delay: slideAutoplaySpeed,
    } : false,
    allowTouchMove: true,
    loop: slideCount > 1,
    // ナビゲーション（矢印）
    navigation: slideArrow ? {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    } : false,
    // ページネーション（ドット）
    pagination: slideDot ? {
      el: ".swiper-pagination",
      clickable: true,
    } : false,
  });
};

/**
 * 個別設定(caizu様) 値をLine Item Propertyにセットする処理
 */
tob.cart.setLineItemProperties = async function() {
  const maxRetries = 5;// 最大5回まで再試行
  const delay = 300;// リトライまでの待機時間（0.3秒）

  // ---------------------------------
  // 1. HTMLから販売価格の更新対象を取得
  // ---------------------------------
  const elements = document.querySelectorAll(
    '[data-line-item-key][data-line-item-value]'
  );

  // 販売価格が設定された商品がなければ何もしない
  if (!elements.length) {
    console.log('販売価格の更新対象なし');
    return true;
  }

  // ---------------------------------
  // 2. カート操作をロック
  // ---------------------------------
  tob.cart.setLineItemProperties.lockCheckout();

  try {
    // ---------------------------------
    // 3. 現在のカート情報を取得
    // ---------------------------------
    const cartResponse = await fetch('/cart.js', {
      headers: {
        'Cache-Control': 'no-cache'
      }
    });

    if (!cartResponse.ok) {
      throw new Error('カート情報の取得に失敗しました。');
    }
    const cart = await cartResponse.json();

    // ---------------------------------
    // 4. 更新が必要な商品だけ抽出
    // ---------------------------------
    const updateItems = Array.from(elements).filter((element) => {

      // HTMLからLine Item Keyと設定したい販売価格を取得
      const key = element.dataset.lineItemKey;
      const targetSalePrice = element.dataset.lineItemValue.trim();
      // カート内から同じLine Item Keyの商品を探す
      const cartItem = cart.items.find(
        (item) => item.key === key
      );

      // カート内に商品がなければ対象外
      if (!cartItem) {
        return false;
      }

      // 現在カートに設定されている販売価格を取得
      const currentSalePrice = cartItem.properties?.['販売価格'];

      // すでに同じ販売価格なら更新不要
      return currentSalePrice !== targetSalePrice;
    });

    // 更新が必要な商品がなければ終了
    if (!updateItems.length) {
      console.log('Line Item Property 更新対象なし');
      // 更新対象がない場合もローディングを解除
      tob.cart.setLineItemProperties.unlockCheckout();
      return true;
    }

    // ---------------------------------
    // 5. 更新が必要な商品を1件ずつ更新
    // ---------------------------------
    for (const element of updateItems) {
      // HTMLから更新対象のLine Item Keyと販売価格を取得
      const lineItemKey = element.dataset.lineItemKey;
      const lineItemValue = element.dataset.lineItemValue.trim();
      let updated = false;// 更新成功フラグ

      // 通信に失敗した場合は複数回再試行
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          // 更新前に取得したカートから対象商品を取得
          const currentItem = cart.items.find(
            (item) => item.key === lineItemKey
          );

          // 商品が見つからなければ更新失敗
          if (!currentItem) {
            throw new Error(
              '更新対象の商品がカートに見つかりません。'
            );
          }

          // ---------------------------------
          // Line Item Propertyを更新
          // ---------------------------------
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: currentItem.key,
              quantity: currentItem.quantity,
              properties: {
                ...(currentItem.properties || {}),
                '販売価格': lineItemValue
              }
            })
          });

          if (response.ok) {
            console.log(`【成功】販売価格を更新しました（${attempt}回目）`,
              {
                key: currentItem.key,
                salePrice: lineItemValue
              }
            );
            updated = true;
            break;
          }
          console.warn(`【警告】販売価格の更新に失敗（${attempt}回目）`);

        } catch (error) {
          console.error(
            `【エラー】販売価格の更新エラー（${attempt}回目）`,
            error
          );
        }

        // 連続リクエストによる失敗を防ぐため、次のリトライまで少し待機
        if (attempt < maxRetries) {
          await new Promise((resolve) => {
            setTimeout(resolve, delay);
          });
        }
      }

      // 5回試しても更新できなければ失敗
      if (!updated) {
        throw new Error(
          '販売価格の更新に失敗しました。'
        );
      }
    }

    // ---------------------------------
    // 6. 更新後のカートを確認
    // ---------------------------------
    // 全商品の販売価格が正しく設定されたかフラグ
    let allPropertiesSet = false;

    // Propertyの反映を複数回確認
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      // 更新後の最新カート情報を取得
      const updatedCartResponse = await fetch('/cart.js', {
        headers: {
          'Cache-Control': 'no-cache'
        }
      });
      // カート情報を取得できなければエラー
      if (!updatedCartResponse.ok) {
        throw new Error('カート情報の取得に失敗しました。');
      }
      // レスポンスをカート情報として取得
      const updatedCart = await updatedCartResponse.json();

      // 更新対象の商品がすべて正しく更新されているか確認
      allPropertiesSet = Array.from(updateItems).every((element) => {
        // HTMLからLine Item Keyと設定する販売価格を取得
        const key = element.dataset.lineItemKey;
        const expectedSalePrice = element.dataset.lineItemValue.trim();
        // Property更新後はKeyが変わる可能性があるためVariant IDで探す
        const variantId = Number(key.split(':')[0]);
        const cartItem = updatedCart.items.find(
          (item) => item.variant_id === variantId
        );
        const salePrice = cartItem?.properties?.['販売価格'];

        console.log(`Line Item Property確認（${attempt}回目）:`, {
          key: cartItem?.key,
          product: cartItem?.product_title,
          expectedSalePrice: expectedSalePrice,
          salePrice: salePrice
        });

        return salePrice === expectedSalePrice;
      });

      // 全商品確認OK
      if (allPropertiesSet) {
        break;
      }

      // 連続リクエストによる失敗を防ぐため、次のリトライまで少し待機
      if (attempt < maxRetries) {
        await new Promise((resolve) => {
          setTimeout(resolve, delay);
        });
      }
    }

    // 複数回確認してもダメなら失敗
    if (!allPropertiesSet) {
      throw new Error(
        'Line Item Propertyのセットを確認できませんでした。'
      );
    }

    // ---------------------------------
    // 7. 完了
    // ---------------------------------
    // 成功した場合だけロック解除
    tob.cart.setLineItemProperties.unlockCheckout();
    console.log(
      '【完了】Line Item Propertyの更新が完了しました'
    );
    return true;

  } catch (error) {
    console.error(error);
    // 最終的に失敗した場合は再試行ボタンを表示
    tob.cart.setLineItemProperties.showError();
    return false;
  }
};

/**
 * 購入導線を無効化
 */
tob.cart.setLineItemProperties.lockCheckout = function () {
  document.body.classList.add('cart-updating');
};


/**
 * 購入導線を有効化
 */
tob.cart.setLineItemProperties.unlockCheckout = function () {
  document.body.classList.remove('cart-updating');
};


/**
 * Line Item Propertyのセットに失敗した場合のエラー処理
 */
tob.cart.setLineItemProperties.showError = function () {

  // すでにエラー表示があるか確認
  let errorElement = document.querySelector(
    '[data-line-item-property-error]'
  );

  // エラー表示がなければ作成
  if (!errorElement) {
    errorElement = document.createElement('div');

    // エラー表示を識別するための属性を付与
    errorElement.setAttribute(
      'data-line-item-property-error',
      ''
    );

    // エラーメッセージと再試行ボタンを表示
    errorElement.innerHTML = `
      <p>カート情報の更新に失敗しました。</p>
      <button type="button" data-line-item-property-retry>
        再試行
      </button>
    `;

    // 画面の先頭にエラーを表示
    document.body.prepend(errorElement);
  }

  // エラー表示を表示状態にする
  errorElement.style.display = 'block';

  // 「再試行」ボタンを取得
  const retryButton = errorElement.querySelector(
    '[data-line-item-property-retry]'
  );

  // 「再試行」が押されたら、Line Item Propertyのセットをもう一度実行
  retryButton.onclick = async function () {

    // エラー表示を一旦隠す
    errorElement.style.display = 'none';

    // Line Item Propertyのセット処理を再実行
    await tob.cart.setLineItemProperties();
  };
};



/*
* ========================================
* 初期処理
* ========================================
*/
window.addEventListener('load', function () {
  // ----------------------------------------
  // Common
  // ----------------------------------------  
  // ヘッダーのおすすめアイテムのスライダー
  if($('.js-header-recommend').length){
    tob.common.recommendSlider();
  }

  // 一括カート追加の際に、カート更新のダイアログを表示
  if($('quick-add-bulk').length){
    tob.common.cartUpdatePopup();
  }

  // ロゴ縮小の制御
  if ($('.header__heading-logo').length) {
    // tob.common.headerLogoShrink();
  }

  // 商品リストで、スウォッチ画像をスライド
  if (document.querySelector('.js-card-variant-swiper')) {
    tob.common.cardProductSlider();
  }


  // ----------------------------------------
  // Top
  // ----------------------------------------
  if ($('.page-index').length) {
    // メインビジュアルのスライダー
    if($('.js-home-visual-swiper').length){
      tob.top.mainvisual();
    }
  }
});

// DOM読み込み後
document.addEventListener('DOMContentLoaded', function () {
  // ----------------------------------------
  // Cart
  // ----------------------------------------
  if (document.querySelector('.page-cart')) {
    // 個別設定(caizu様) 値をLine Item Propertyにセットする処理
    tob.cart.setLineItemProperties ();
  }

});